import { airportsColorTheme } from '../styles/Color';
import { AirportCodes } from '../types/airports';

export const getAirportColorTheme = (airport: AirportCodes) =>
	airportsColorTheme[airport];
